import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Container,
    Paper,
    Typography,
    Button,
    Box,
    Avatar,
    Divider,
    Link
} from '@mui/material';
import {
    Cancel as CancelIcon,
    Payment as PaymentIcon,
    Home as HomeIcon
} from '@mui/icons-material';
import { CancelPayment } from 'components/logic/paymentgateway/CancelPayment';

const CancelPage = () => {
    const navigate = useNavigate();
    const sessionId = new URLSearchParams(window.location.search).get('session_id');
    const [isCanceled, setIsCanceled] = useState(false);


    const cancelPayment = async (sessionId) => {
        try {
            const response = await CancelPayment(sessionId);
            if (!response.isError) {
                setIsCanceled(true);
            } else {
                setIsCanceled(false);
            }
        } catch (error) {
            console.error("Error Canceling checkout:", error);
        }
    }
    useEffect(() => {
        if (sessionId == null || sessionId === undefined) {
            console.warn("Session ID is missing. Redirecting to home page.");
            navigate('/');
        } else {
            cancelPayment(sessionId);
        }
    }, [sessionId]);

    return (
        <>
            {isCanceled && (
                <Container maxWidth="sm" sx={{ py: 4 }}>
                    <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
                            <Avatar sx={{ bgcolor: 'error.light', width: 80, height: 80 }}>
                                <CancelIcon sx={{ fontSize: 48 }} />
                            </Avatar>
                        </Box>

                        <Typography variant="h4" gutterBottom>
                            Payment Cancelled
                        </Typography>
                        <Typography variant="body1" color="text.secondary" gutterBottom>
                            Your payment was not completed. You can try again or choose a different payment method.
                        </Typography>

                        <Box sx={{ mt: 4, '& > *': { mb: 2 } }}>
                            {/* <Button
                        fullWidth
                        variant="contained"
                        color="error"
                        size="large"
                        onClick={() => navigate('/checkout')}
                        startIcon={<PaymentIcon />}
                    >
                        Try Again
                    </Button> */}

                            <Button
                                fullWidth
                                variant="outlined"
                                color="error"
                                size="large"
                                onClick={() => navigate('/')}
                                startIcon={<HomeIcon />}
                            >
                                Return to Dashboard
                            </Button>
                        </Box>

                        <Divider sx={{ my: 3 }} />

                        <Typography variant="body2" color="text.secondary">
                            Having trouble? <Link href="mailto:support@cleri.ai">Contact support</Link>
                        </Typography>
                    </Paper>
                </Container>
            )}
        </>
    );
};

export default CancelPage;